import CuentaCorriente from "./CuentaCorriente";

export default CuentaCorriente;
